import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { getSection } from "@/data/siteContent";
import { COLORS } from "@/lib/api";
import ComingSoon from "@/components/ComingSoon";

const SectionPage = ({ sectionKey }) => {
  const section = getSection(sectionKey);
  if (!section) return null;
  if (!section.ready) return <ComingSoon section={section} />;
  const accent = COLORS[section.color];

  return (
    <div data-testid={`section-${section.key}`}>
      {/* Hero */}
      <section className="border-b border-[#E5E5E5]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <span
              className="inline-block w-16 h-1.5 rounded-sm mb-6"
              style={{ background: accent }}
            />
            <h1 className="font-heading text-5xl md:text-6xl font-black tracking-tighter text-brand-ink">
              {section.title}
            </h1>
            <p className="mt-5 text-lg md:text-xl text-brand-ink/70 leading-relaxed max-w-xl">
              {section.intro}
            </p>
          </div>
          <div className="lg:col-span-5 relative">
            <div
              className="absolute -bottom-3 -right-3 w-full h-full rounded-sm"
              style={{ background: accent }}
            />
            <img
              src={section.image}
              alt={section.title}
              className="relative w-full h-72 object-cover rounded-sm"
            />
          </div>
        </div>
      </section>

      {/* Subpages */}
      <section className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {section.subpages.map((sub, i) => (
            <motion.div
              key={sub.slug}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: (i % 3) * 0.08 }}
            >
              <Link
                to={`${section.path}/${sub.slug}`}
                data-testid={`subpage-card-${sub.slug}`}
                className="group block h-full bg-white border border-[#E5E5E5] p-7 rounded-sm transition-all duration-300 hover:-translate-y-1"
                onMouseEnter={(e) => (e.currentTarget.style.borderColor = accent)}
                onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#E5E5E5")}
              >
                <span className="font-mono text-sm text-brand-ink/40">
                  0{i + 1}
                </span>
                {!sub.ready && (
                  <span className="ml-3 text-[10px] uppercase tracking-[0.12em] font-bold text-brand-ink/50 bg-[#F0F0F0] px-2 py-1 rounded-sm">
                    Próximamente
                  </span>
                )}
                <h3 className="mt-3 font-heading text-2xl font-bold tracking-tight text-brand-ink">
                  {sub.title}
                </h3>
                <p className="mt-2 text-brand-ink/70 leading-relaxed">{sub.intro}</p>
                <span className="mt-5 inline-flex items-center gap-1 font-semibold text-brand-ink group-hover:gap-2 transition-all">
                  Ver más <ArrowUpRight size={18} />
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default SectionPage;
